export default __webpack_public_path__ + "static/media/balance-icon.1c1d5543.svg";